import { SearchTerm } from "../models/search/SearchTerm";

export const findSearchAccessorOnName = (searchDescriptor) => {
    return searchDescriptor.find(search => search.accessor === 'name')?.searchOnName;
}

export const buildSearchTerm = (accessor, newSearchTerm): SearchTerm => {
    return {
        accessor: accessor,
        translationKey: accessor,
        value: newSearchTerm
    }
}
